import {Injectable, Inject} from '@angular/core';
import {Observable} from 'rxjs';
import {SoundcloudChannel, SoundCloudApiSearchResult} from "../../modele/social-media/soundcloudModels";
import {HttpHeaders, HttpClient, HttpResponse} from '@angular/common/http';
import {NGXLogger} from "ngx-logger";
import {BackendService} from "../api/backend.service";
import {TwitchChannel, TwitchAuthorization} from "../../modele/social-media/twitchModels";
import {HttpOptions} from '../../modele/authModel';


export const SOUNDCLOUD_API_KEY = 'ff053537b4f0e6aa1f64e17249e65078';
export const SOUNDCLOUD_API_URL = 'https://api.soundcloud.com/users';

@Injectable({
    providedIn: 'root'
})
export class SoundcloudService {
    userToken = "yahb1eg5ilr16hsabnu8orc7psmrke";
    private local_auth:TwitchAuthorization;
    log_prefix = this.constructor.name + ":";

    constructor(private http: HttpClient,
                @Inject(SOUNDCLOUD_API_KEY) private apiKey: string,
                @Inject(SOUNDCLOUD_API_URL) private apiUrl: string,
                private logger: NGXLogger,
                private bes: BackendService,

    ) {
         this.getBackendAuthorization();
    }

    search(query: string): Observable <SoundcloudChannel[] > {
        const access_token = this.local_auth.access_token;
        const headers = new HttpHeaders({'Authorization': 'Bearer ' + access_token});
        let options = new HttpOptions();
        let lp = this.log_prefix + "search:";


        const params = `?q=${query}&client_id=${this.apiKey}`;
        const queryUrl = `${this.apiUrl}${params}`;
        return new Observable<SoundcloudChannel[]>((observer) => {
            // let list : VimeoChannel[] = [];
            this.http.get<SoundCloudApiSearchResult[]>(queryUrl,options).subscribe((resp:SoundCloudApiSearchResult[]) => {
                let parsedData = resp.map(ele=>{
                    let parsedResp=new SoundcloudChannel(ele);
                    return parsedResp;
                });
                observer.next(parsedData);
            });
        });
    }

    gettracks(query: string): Observable <any[] > {
        const access_token = this.local_auth.access_token;
        const headers = new HttpHeaders({'Authorization': 'Bearer ' + access_token});
        let options = new HttpOptions();

        let lp = this.log_prefix + "gettracks:";

        const params = `/${query}`;
        const queryUrl = `${this.apiUrl}${params}`;
        return new Observable<any[]>((observer) => {
            // let list : VimeoChannel[] = [];
            this.http.get<SoundCloudApiSearchResult[]>(queryUrl,options).subscribe((resp:SoundCloudApiSearchResult[]) => {
                let parsedData = resp.map(ele=>{

                    let parsedResp=ele;
                    return parsedResp;
                });
                observer.next(parsedData);
            });
        });
    }
    private getBackendAuthorization() {
        let lp=this.log_prefix+"getBackendAuthorization:";
        this.http.get(this.bes.twitchAuthorization()).subscribe((resp:TwitchAuthorization)=>{
            let {access_token} = resp['feeds'];
            let {token_type} = resp['feeds'];
            let {expires_in} = resp['feeds'];
            this.local_auth = resp['feeds'];
        })
    }


}
